import { AggregatePeriod } from 'v2/core/entities';
import { QuantifyQuery, QuantifyState } from '../store/types';

export type getQuantifyAnalysisURLInput = Partial<QuantifyQuery> &
  Partial<
    Pick<
      QuantifyState['metadata'],
      | 'activeVisualisationType'
      | 'shouldShowCategories'
      | 'shouldShowCooccurringDataPoints'
    >
  > & {
    groupByValue?: string;
    visibleDataPoints?: string[];
    aggregatePeriod?: AggregatePeriod;
    measuredAsCriteriaValue?: string;
  };

export function getQuantifyAnalysisURL(object: getQuantifyAnalysisURLInput) {
  const params: string[] = [];

  for (const [key, value] of Object.entries(object)) {
    if (value === undefined || value === null) {
      continue;
    }

    const valueStr =
      Object(value) === value ? JSON.stringify(value) : String(value);

    params.push(`${key}=${encodeURIComponent(valueStr)}`);
  }

  return params.join('&');
}
